import {DataQueriesDispatcher} from '../core/dispatchers'
import {IDataQueriesDispatcher} from '../core/interfaces/dispatchers'
import {appFeatureTablesDispatcher} from './appFeatureTablesDispatcher'

class AppDataQueriesDispatcher extends DataQueriesDispatcher {}

export const appDataQueriesDispatcher = new AppDataQueriesDispatcher(
  appFeatureTablesDispatcher
) as IDataQueriesDispatcher
